"use strict";


import Headroom from "../../headroom.js";
import Splide from "../../splide.min.js";
import ScrollMagic from "../../Librairie/scrollMagic/ScrollMagic_2.0.8.min.js";

function _typeof(t) {
      return (_typeof =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                  ? function (t) {
                        return typeof t;
                  }
                  : function (t) {
                        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                  })(t);
}
var jschecker;
function init() {
      var i, t, o;
      (jschecker = checkLoaded())
            ? (console.log("Script started"),
                  (t = this),
                  (o = function () {
                        function t() {
                              return "undefined" != typeof window;
                        }
                        function o(t, n, s) {
                              var o,
                                    e,
                                    i,
                                    r,
                                    l,
                                    c,
                                    a,
                                    h = (function () {
                                          var t = !1;
                                          try {
                                                var o = {
                                                      get passive() {
                                                            t = !0;
                                                      },
                                                };
                                                window.addEventListener("test", o, o), window.removeEventListener("test", o, o);
                                          } catch (o) {
                                                t = !1;
                                          }
                                          return t;
                                    })(),
                                    d = !1,
                                    u =
                                          (e = t) && e.document && 9 === e.document.nodeType
                                                ? ((l = (r = e).document),
                                                      (c = l.body),
                                                      (a = l.documentElement),
                                                {
                                                      scrollHeight: function () {
                                                            return Math.max(c.scrollHeight, a.scrollHeight, c.offsetHeight, a.offsetHeight, c.clientHeight, a.clientHeight);
                                                      },
                                                      height: function () {
                                                            return r.innerHeight || a.clientHeight || c.clientHeight;
                                                      },
                                                      scrollY: function () {
                                                            return void 0 !== r.pageYOffset ? r.pageYOffset : (a || c.parentNode || c).scrollTop;
                                                      },
                                                })
                                                : ((i = e),
                                                {
                                                      scrollHeight: function () {
                                                            return Math.max(i.scrollHeight, i.offsetHeight, i.clientHeight);
                                                      },
                                                      height: function () {
                                                            return Math.max(i.offsetHeight, i.clientHeight);
                                                      },
                                                      scrollY: function () {
                                                            return i.scrollTop;
                                                      },
                                                }),
                                    f = u.scrollY(),
                                    p = {};
                              function m() {
                                    var t = Math.round(u.scrollY()),
                                          o = u.height(),
                                          e = u.scrollHeight();
                                    (p.scrollY = t),
                                          (p.lastScrollY = f),
                                          (p.direction = f < t ? "down" : "up"),
                                          (p.distance = Math.abs(t - f)),
                                          (p.isOutOfBounds = t < 0 || e < t + o),
                                          (p.top = t <= n.offset[p.direction]),
                                          (p.bottom = e <= t + o),
                                          (p.toleranceExceeded = p.distance > n.tolerance[p.direction]),
                                          s(p),
                                          (f = t),
                                          (d = !1);
                              }
                              function g() {
                                    d || ((d = !0), (o = requestAnimationFrame(m)));
                              }
                              var y = !!h && { passive: !0, capture: !1 };
                              return (
                                    t.addEventListener("scroll", g, y),
                                    m(),
                                    {
                                          destroy: function () {
                                                cancelAnimationFrame(o), t.removeEventListener("scroll", g, y);
                                          },
                                    }
                              );
                        }
                        function e(t) {
                              return t === Object(t) ? t : { down: t, up: t };
                        }
                        function n(t, o) {
                              (o = o || {}),
                                    Object.assign(this, n.options, o),
                                    (this.classes = Object.assign({}, n.options.classes, o.classes)),
                                    (this.elem = t),
                                    (this.tolerance = e(this.tolerance)),
                                    (this.offset = e(this.offset)),
                                    (this.initialised = !1),
                                    (this.frozen = !1);
                        }
                        return (
                              (n.prototype = {
                                    constructor: n,
                                    init: function () {
                                          return (
                                                n.cutsTheMustard &&
                                                !this.initialised &&
                                                (this.addClass("initial"),
                                                      (this.initialised = !0),
                                                      setTimeout(
                                                            function (t) {
                                                                  t.scrollTracker = o(t.scroller, { offset: t.offset, tolerance: t.tolerance }, t.update.bind(t));
                                                            },
                                                            100,
                                                            this
                                                      )),
                                                this
                                          );
                                    },
                                    destroy: function () {
                                          (this.initialised = !1), Object.keys(this.classes).forEach(this.removeClass, this), this.scrollTracker.destroy();
                                    },
                                    unpin: function () {
                                          (!this.hasClass("pinned") && this.hasClass("unpinned")) || (this.addClass("unpinned"), this.removeClass("pinned"), this.onUnpin && this.onUnpin.call(this));
                                    },
                                    pin: function () {
                                          this.hasClass("unpinned") && (this.addClass("pinned"), this.removeClass("unpinned"), this.onPin) && this.onPin.call(this);
                                    },
                                    freeze: function () {
                                          (this.frozen = !0), this.addClass("frozen");
                                    },
                                    unfreeze: function () {
                                          (this.frozen = !1), this.removeClass("frozen");
                                    },
                                    top: function () {
                                          this.hasClass("top") || (this.addClass("top"), this.removeClass("notTop"), this.onTop && this.onTop.call(this));
                                    },
                                    notTop: function () {
                                          this.hasClass("notTop") || (this.addClass("notTop"), this.removeClass("top"), this.onNotTop && this.onNotTop.call(this));
                                    },
                                    bottom: function () {
                                          this.hasClass("bottom") || (this.addClass("bottom"), this.removeClass("notBottom"), this.onBottom && this.onBottom.call(this));
                                    },
                                    notBottom: function () {
                                          this.hasClass("notBottom") || (this.addClass("notBottom"), this.removeClass("bottom"), this.onNotBottom && this.onNotBottom.call(this));
                                    },
                                    shouldUnpin: function (t) {
                                          return "down" === t.direction && !t.top && t.toleranceExceeded;
                                    },
                                    shouldPin: function (t) {
                                          return ("up" === t.direction && t.toleranceExceeded) || t.top;
                                    },
                                    addClass: function (t) {
                                          this.elem.classList.add.apply(this.elem.classList, this.classes[t].split(" "));
                                    },
                                    removeClass: function (t) {
                                          this.elem.classList.remove.apply(this.elem.classList, this.classes[t].split(" "));
                                    },
                                    hasClass: function (t) {
                                          return this.classes[t].split(" ").every(function (t) {
                                                return this.classList.contains(t);
                                          }, this.elem);
                                    },
                                    update: function (t) {
                                          t.isOutOfBounds || (!0 !== this.frozen && (t.top ? this.top() : this.notTop(), t.bottom ? this.bottom() : this.notBottom(), this.shouldUnpin(t) ? this.unpin() : this.shouldPin(t) && this.pin()));
                                    },
                              }),
                              (n.options = {
                                    tolerance: { up: 0, down: 0 },
                                    offset: 0,
                                    scroller: t() ? window : null,
                                    classes: {
                                          frozen: "headroom--frozen",
                                          pinned: "headroom--pinned",
                                          unpinned: "headroom--unpinned",
                                          top: "headroom--top",
                                          notTop: "headroom--not-top",
                                          bottom: "headroom--bottom",
                                          notBottom: "headroom--not-bottom",
                                          initial: "headroom",
                                    },
                              }),
                              (n.cutsTheMustard = !!(t() && function () { }.bind && "classList" in document.documentElement && Object.assign && Object.keys && requestAnimationFrame)),
                              n
                        );
                  }),
                  "object" == ("undefined" == typeof exports ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? (module.exports = o()) : "function" == typeof define && define.amd ? define(o) : ((t = t || self).Headroom = o()),
                  (t = document.querySelector("#header")),
                  new Headroom(t).init(),
                  (i = new ScrollMagic.Controller()),
                  document.querySelectorAll(".Template_T9__bloc-produit-item picture").forEach(function (t, o) {
                        var e, n, s;
                        (e = "onEnter"), (n = o = ".Template_T9__bloc-produit-item:nth-child(" + (o + 1) + ")"), (s = "unzoom"), document.querySelector(n) && new ScrollMagic.Scene({ triggerElement: o, triggerHook: e }).setClassToggle(n, s).addTo(i);
                  }))
            : setTimeout(init);
}
function checkLoaded() {
      return console.log("page is fully loaded"), !0;
}
init();
